<template>
    <v-chip label class="customer-type white--text" :color="value.is_company ? 'purple' : 'green'">
        <abbr title="Bedriftskunde" v-if="value.is_company">B</abbr><abbr title="Privatkunde" v-else>P</abbr><abbr title="Leasingkunde" v-if="value.is_leasing">L</abbr>
    </v-chip>
</template>

<script>
    export default {
        props: {
            value: Object
        }
    }
</script>

<style>
    .customer-type {
    }

    .customer-type abbr {
        padding: 0 0.1rem;
        font-weight: bold;
        border-bottom: 0;
        opacity: 0.8;
    }
</style>